/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown>, count: NonNullable<unknown> }} Clients_Table_Fleet_EntryInputs */

const en_clients_table_fleet_entry = /** @type {(inputs: Clients_Table_Fleet_EntryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} ${i?.count}`)
};

const pt_br2_clients_table_fleet_entry = /** @type {(inputs: Clients_Table_Fleet_EntryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{type} {count}" |
*
* @param {Clients_Table_Fleet_EntryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_table_fleet_entry = /** @type {((inputs: Clients_Table_Fleet_EntryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Table_Fleet_EntryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_table_fleet_entry(inputs)
	return pt_br2_clients_table_fleet_entry(inputs)
});